import React from "react";
import ig from "../images/ig.png";

const Footer = () => {
  return (
    <footer className="z-[20] fixed bottom-0 left-0 right-0 flex items-center justify-between bg-lightblack text-white h-12 border-t-2 border-yellow max-w-screen py-2 hidden md:flex">
      <div className="text-center pl-10">
      <a href="https://www.instagram.com/westmorebjj/" target="_blank" rel="noopener noreferrer">
          <img src={ig} width="30px"></img>
        </a>
      </div>
      <div className="text-right ml-auto pr-4">© 2026 Westmore Brazilian Jiu Jitsu</div>
    </footer>
  );
};

export default Footer;
